import React, { Component } from "react";
import { authService } from "../../../auth";
import axios from "axios";
import { getFormattedDate } from "../../../Donation/DonationCommonFunction";
import Scrollbars from "react-custom-scrollbars";

class EntityRestrictedPopUp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            historyDetails: [],
            pageNo: 0, 
            pageSize: 10
        }
    }

    getUserRestrictedHistory = (data, page, size, concatWithPrevious) => {
        axios({
            method: 'GET',
            url: `${process.env.REACT_APP_userServiceURL}/backend/participant/history/get?entityId=${data.projectId}&entityType=${data.entityType}&participationType=${data.participationType}&userId=${data.userId}&requestingUserId=${this.state.userData.userId}&page=${page}&size=${size}`,
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.body && response.data.message === 'Success!') {
                let pageData = response.data.body;
                if (concatWithPrevious && pageData && pageData.content) {
                    pageData.content = this.state.historyDetails.content.concat(pageData.content);
                }
                this.setState({
                    historyDetails: response.data.body
                })
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    getMoreHistoryData = () => {
        this.setState({
            pageNo: this.state.pageNo + 1
        }, () => {
            this.getUserRestrictedHistory(this.props.entityRestrictedData, this.state.pageNo, this.state.pageSize, true);
        })
    }

    componentDidMount() {
        this.getUserRestrictedHistory(this.props.entityRestrictedData, this.state.pageNo, this.state.pageSize, false);
    }

    render() {
        const {historyDetails} = this.state;
        return (
            <div id={"entityRestrictedPopUp"} className="modal fade dgpopup reqendorse historyPop" tabIndex="-1" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog likesblk">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="similarAllpopWrap forwcontwrap" style={{ maxWidth: "450px", position: "relative" }}>
                                <button type="button" className="close topCrossModal" aria-label="Close" onClick={this.props.onCloseRestrictionPopUp}>
                                    <i className="iCross" />
                                </button>
                                <div>
                                    <div className="similarAllpopHeader">
                                        <h2>History</h2>
                                    </div>
                                    <div className={"similarAllpopBody"}>
                                        <Scrollbars
                                            className={"forwcontlistmain "}
                                            autoHide
                                            autoHeight
                                            autoHeightMin={0}
                                            autoHeightMax={322}
                                            universal={true}
                                            renderTrackHorizontal={(props) => (
                                                <div {...props} className="track-horizontal" />
                                            )}
                                            renderTrackVertical={(props) => (
                                                <div {...props} className="track-vertical" />
                                            )}
                                        >                                            
                                            <div>
                                                {historyDetails && historyDetails.content?.length > 0 &&
                                                    <div className={"sProjectListRow historyHead"}>
                                                        <div class="selectBank">
                                                            <label>Status</label>
                                                        </div>
                                                        <div class="selectBank text-right">
                                                            <label>Start Time</label>
                                                        </div>
                                                        <div class="selectBank text-right">
                                                            <label>End Time</label>
                                                        </div>
                                                    </div>
                                                }
                                                {historyDetails && historyDetails.content?.length > 0 && historyDetails.content.map((data) => {
                                                    return (
                                                        <li>
                                                            <div className="userBlk">
                                                                <div><h5 className="name">{data.status}</h5></div>
                                                            </div>
                                                            <div class="donateDate text-right">
                                                                <span>{getFormattedDate(data.startTime)}</span>
                                                            </div>
                                                            <div class="donateDate text-right">
                                                                <span>{data.endTime != 0 ? getFormattedDate(data.endTime) : "-"}</span>
                                                            </div>
                                                        </li>
                                                    )})}
                                                    
                                            </div>
                                        </Scrollbars>
                                        {!historyDetails?.last &&
                                            <div className="btnblock text-center">
                                                <button className="btn morebtnsm" onClick={(e) => this.getMoreHistoryData()}>Show more</button>
                                            </div>
                                        }
                                        {historyDetails && historyDetails.content?.length === 0 &&
                                            <div className="zdata">
                                                <div className="desc">
                                                    <h4>No data available.</h4>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>            
        )
    }
}

export default EntityRestrictedPopUp;